import { fetchLUTForInstance } from './fetchLUTForInstance';
function convertLUTto8Bit(lut, shift) {
    const numEntries = lut.length;
    const cleanedLUT = new Uint8ClampedArray(numEntries);
    for (let i = 0; i < numEntries; ++i) {
        cleanedLUT[i] = lut[i] >> shift;
    }
    return cleanedLUT;
}
export default function convertPaletteColor(imageFrame, colorBuffer, useRGBA) {
    const numPixels = imageFrame.columns * imageFrame.rows;
    const pixelData = imageFrame.pixelData;
    const rData = imageFrame.redPaletteColorLookupTableData;
    const gData = imageFrame.greenPaletteColorLookupTableData;
    const bData = imageFrame.bluePaletteColorLookupTableData;
    if (!rData || !gData || !bData) {
        throw new Error('The image does not have a complete color palette. R, G, and B palette data are required.');
    }
    const len = rData.length;
    let palIndex = 0;
    let bufferIndex = 0;
    const start = imageFrame.redPaletteColorLookupTableDescriptor[1];
    const bitsStored = imageFrame.redPaletteColorLookupTableDescriptor[2];
    const shift = bitsStored > 8 || rData.some((num) => num > 255) ? 8 : 0;
    const rDataCleaned = convertLUTto8Bit(rData, shift);
    const gDataCleaned = convertLUTto8Bit(gData, shift);
    const bDataCleaned = convertLUTto8Bit(bData, shift);
    if (useRGBA) {
        for (let i = 0; i < numPixels; ++i) {
            let value = pixelData[palIndex++];
            if (value < start) {
                value = 0;
            }
            else if (value > start + len - 1) {
                value = len - 1;
            }
            else {
                value -= start;
            }
            colorBuffer[bufferIndex++] = rDataCleaned[value];
            colorBuffer[bufferIndex++] = gDataCleaned[value];
            colorBuffer[bufferIndex++] = bDataCleaned[value];
            colorBuffer[bufferIndex++] = 255;
        }
        return;
    }
    for (let i = 0; i < numPixels; ++i) {
        let value = pixelData[palIndex++];
        if (value < start) {
            value = 0;
        }
        else if (value > start + len - 1) {
            value = len - 1;
        }
        else {
            value -= start;
        }
        colorBuffer[bufferIndex++] = rDataCleaned[value];
        colorBuffer[bufferIndex++] = gDataCleaned[value];
        colorBuffer[bufferIndex++] = bDataCleaned[value];
    }
}
export async function convertPaletteColorWithFetch(imageFrame, colorBuffer, useRGBA) {
    await fetchLUTForInstance(imageFrame);
    convertPaletteColor(imageFrame, colorBuffer, useRGBA);
}
